var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "provenance-graph-wrap" }, [
    _c("div", { staticClass: "provenance-graph-heading" }, [
      _c("div", { staticClass: "provenance-summary" }, [
        _vm._v(
          _vm._s(_vm.activityCount) +
            " stages, " +
            _vm._s(_vm.resourceCount) +
            " resources"
        ),
      ]),
      _c("div", { staticClass: "provenance-hint" }, [
        _vm._v(
          "Data flows from top to bottom. Scroll to zoom and drag to pan."
        ),
      ]),
    ]),
    _c("div", { staticClass: "graph-canvas" }, [
      _c(
        "div",
        {
          staticClass: "graph-controls",
          attrs: { role: "toolbar", "aria-label": "Graph controls" },
        },
        [
          _c(
            "b-button",
            {
              staticClass: "graph-control-button",
              attrs: { size: "sm", title: "Zoom out" },
              on: { click: _vm.zoomOut },
            },
            [_c("b-icon-zoom-out", { attrs: { "aria-hidden": "true" } })],
            1
          ),
          _c("span", { staticClass: "zoom-level" }, [
            _vm._v(_vm._s(_vm.zoomLevel) + "%"),
          ]),
          _c(
            "b-button",
            {
              staticClass: "graph-control-button",
              attrs: { size: "sm", title: "Zoom in" },
              on: { click: _vm.zoomIn },
            },
            [_c("b-icon-zoom-in", { attrs: { "aria-hidden": "true" } })],
            1
          ),
          _c(
            "b-button",
            {
              staticClass: "graph-control-button",
              attrs: { size: "sm", title: "Fit graph to view" },
              on: { click: _vm.fitGraph },
            },
            [
              _c("b-icon-arrows-fullscreen", {
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" Fit "),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", {
        ref: "graph",
        staticClass: "provenance-graph",
        style: { height: `${_vm.graphHeight}px` },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }